import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Redefinepatientservices() {
  return (
    <section
      className="redefinepatient_services p-100 tekgrip_section pwa_tabs_sec"
      style={{ backgroundColor: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} xl={6} xxl={6}>
            <h2>
              Services Offered By The <span>Best PWA</span> Development Company
            </h2>
          </Col>
        </Row>
        <Row className="mt-lg-5 mt-md-3 md-sm-2">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <Tab.Container id="" defaultActiveKey="0">
                <Row>
                  <Col
                    xs={12}
                    md={6}
                    lg={6}
                    xl={6}
                    className="redefine_tabs"
                    style={{ background: "#0B314D" }}
                  >
                    <Nav variant="pills" className="flex-column">
                      <div className="red_item" style={{ overflow: "hidden" }}>
                        <Nav.Item>
                          <Nav.Link eventKey="0">
                            01. Custom-tailored Progressive Web App Solutions
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="1">
                            02. Responsive App Design
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="2">
                            03. Efficient Architecture of Application
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="3">
                            04. Seamless PWA Migration Services
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="4">
                            05. Superior Quality Assurance
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                    </Nav>
                  </Col>
                  <Col xs={12} md={6} lg={6} xl={6} className="p-0">
                    <Tab.Content>
                      <Tab.Pane eventKey="0">
                        <h3>Custom-tailored Progressive Web App Solutions</h3>
                        <p>
                          TekRevol specializes in creating especially customized
                          PWAs that are fully aligned with your overall business
                          goals. Our team aims to build strong relationships
                          with the clients to gain a full understanding of your
                          unique business requirements. In this way, we deliver
                          a PWA that not only drives up your user engagement
                          rate but also takes your business to rapid growth in
                          the future.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="1">
                        <h3>Responsive App Design</h3>
                        <p>
                          We prioritize creating app designs that are responsive
                          and easily adaptable to different devices having
                          different screen sizes. The design approach that we
                          have at TekRevol is primarily not just about the looks
                          and appearance but also about the fact that the app
                          performs well across different platforms, like
                          smartphones, PCs, laptops, or tablets.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="2">
                        <h3>Efficient Architecture of Application</h3>
                        <p>
                          TekRevol ensures that the PWAs have an efficient
                          architecture implemented for the user to have a smooth
                          and secure experience if there is an unstable network
                          connection. It does so by preloading the essential UI
                          Components that eventually result in quick loading and
                          efficient performance of the application.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="3">
                        <h3>Seamless PWA Migration Services</h3>
                        <p>
                          When it comes to transitioning from your existing web
                          or mobile application to a Progressive Web App,
                          TekRevol has simplified the process with its PWA
                          migration services. We handle the entire process of
                          migration to ensure that your application does not
                          lose its core functionality with the added benefits of
                          PWA. We assure you that the entire process will have
                          the minimum downtime and it will not cause any kind of
                          distraction as well.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="4">
                        <h3>Superior Quality Assurance</h3>
                        <p>
                          Quality assurance is an integral part of the entire
                          process. At TekRevol we take strict measures to ensure
                          that the final product is top-notch. We run extensive
                          tests to identify potential issues to make sure that
                          PWA is fully optimized, secure, and ready to use by
                          the clients. We run the final product through three
                          tests: functional testing, performance testing, and
                          compatibility testing to guarantee a high-quality
                          product that meets your expectations.
                        </p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Redefinepatientservices;
